<template>
    <div>
        <named-value :name="title" variant="stacked" />

        <named-value :name="description" secondary variant="stacked" />

        <spacer />

        <template v-if="validFrom && validTo">
            <named-value :name="texts.valid_from">
                {{ validFrom | momentDate }}
            </named-value>

            <named-value :name="texts.valid_to">
                {{ validTo | momentDate }}
            </named-value>

            <named-value :name="texts.number_of_days">
                {{ amountOfDays }} {{ amountOfDays == 1 ? texts.day : texts.days }}
            </named-value>

            <p>
                <named-value :name="texts.validity_period_info_title">
                    <span v-html="texts.validity_period_info"></span>
                </named-value>
            </p>
        </template>
    </div>
</template>

<script>
import NamedValue from "@/components/elements/NamedValue";

export default {
    components: {
        NamedValue
    },
    props: {
        texts: {
            type: Object,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        description: {
            type: String,
            default: null
        },
        validFrom: {
            type: Date,
            default: null
        },
        validTo: {
            type: Date,
            default: null
        },
        amountOfDays: {
            type: Number,
            default: null
        }
    }
};
</script>
